/**
 *
 Created by zhangzhao on 2017/8/14.
 Email: zhangzhao@gomeplus.com
 */
 import getRequest from './getRequest.js';
 let token = getRequest(window.location.search)['token'] || '';
 let isContent = /^\/content/;
 export const requestInter = (fetch) => {
     fetch.interceptors.request.use(function (config) {
 
        //  if (isContent.test(config.url)) {
        //      if(origin.indexOf('atguat')!= -1){
        //          config.baseURL = 'http://activity-erm.atguat.com.cn/'
        //      }else{
        //          if (config.url.substr(0, 9) == "/content/") {
        //              // 赛事管理后台的
        //              config.baseURL = 'http://match-bg.gome.com.cn'
        //          } else {
        //              config.baseURL = 'http://activity-erm.gome.com.cn/'
        //          }
        //      }
         
        //      // config.transformRequest = [
        //      //     function (data) {
        //      //         const param = encodeURIComponent('body') + '=' + new Object(JSON.stringify(data))
        //      //         return param
        //      //     }
        //      // ]
        //  } else {
        //      if (config.params) {
        //          config.params.token = token
        //      }
        //      if (config.method.toUpperCase() == 'POST') {
        //          config.url += '?token=' + token;
        //      }
        //  }
 
 
 
 
         // config['params'] && config['params']['token'] = token;
         let $loadingBox = document.querySelector('.loading-box');
         $loadingBox && ($loadingBox.style.display = 'flex');
         return config;
     }, function (error) {
         return Promise.reject(error);
     });
 }
 
 export const responseInter = (fetch) => {
     fetch.interceptors.response.use(function (response) {
         let $loadingBox = document.querySelector('.loading-box');
         $loadingBox && ($loadingBox.style.display = 'none');
         return response;
     }, function (error) {
         let $loadingBox = document.querySelector('.loading-box');
         $loadingBox && ($loadingBox.style.display = 'none');
 
         if (error.response && error.response.data && error.response.data.code == '101') {
             window.location.href = error.response.data.data.loginUrl;
         }
 
         return Promise.resolve(error.response);
         // return Promise.reject(error);
     });
 }